import React, { useState } from 'react';
import WebsiteLayout from './WebsiteLayout';
import RoboticsBanner from './components/RoboticsBanner';
import RobotServices from './components/RobotServices';
import WhoWeAre from './components/whoweare';
import Industries from './components/industries';
import RoboticsProducts from './components/roboticsProducts';

const RoboticsHome = () => {


    return(<>
    <WebsiteLayout>
     <RoboticsBanner/>
     <RobotServices/>
     <WhoWeAre/>
     <Industries/>
     <RoboticsProducts/>

    </WebsiteLayout>
    </>);


}

export default RoboticsHome;